import {set, get} from 'lodash-es';
import {IPermission} from 'models/permissions';

export type TPermissionChangeCallback = (permission: string[], enable: boolean) => void;

type PermissionsTree = {
  [parent: string]: {
    path: string;
    _id: string;
    name: string;
    category: string;
    displayName: string;
    dependsOn: string[];
    parent?: string;
  }[];
};

// Redundant permission categories for matching Command Center standard, should not be displayed
const redundantPermissionCategories = ['Permit IO'];

export const handleRedundantPermission = (permission: string): string[] => {
  // permission will be in format e.g: resource_create_oo;
  // it should return its redundant form in permit.io standard: resource_oo_create
  const resources = ['oo', 'partner'];
  const separator = '_';
  const currentPerms = [permission];
  resources.forEach(perm => {
    if (permission.includes(perm)) {
      const [resource, action] = permission
        .replace(`${separator}${perm}`, '') // r_action
        .split(separator); // ['r','action']

      const newPerm = [resource, perm, action] //  ['r', perm, 'action']
        .join(separator);

      currentPerms.push(newPerm);
    }
  });

  return currentPerms;
};

export const buildPermissionsTree = (permissions: IPermission[] | undefined): PermissionsTree | null =>
  !permissions
    ? null
    : permissions
        .filter(p => !redundantPermissionCategories.includes(p.category))
        .map(p => ({...p, path: p.category.split('_').join('.')}))
        .reduce((acum, item) => {
          set(
            acum,
            item.path,
            !item.parent
              ? [
                  ...(get(acum, item.path) || []),
                  {name: item.name, displayName: item.displayName, dependsOn: item.dependsOn},
                ]
              : {
                  ...(get(acum, item.path) || {}),
                  [item.parent]: [
                    ...(get(acum, `${item.path}[${item.parent}]`) || []),
                    {name: item.name, displayName: item.displayName, dependsOn: item.dependsOn},
                  ],
                },
          );

          return acum;
        }, {});
